import type { CurrentPeriodResponse } from '../types';

export function definitionProgress(period: CurrentPeriodResponse | null) {
  if (!period) return null;
  const required = period.definitions.filter((definition) => !definition.skipped);
  if (required.length === 0) return null;
  const filled = required.filter((definition) => definition.healthy_looks_like.trim()).length;
  return { filled, total: required.length, complete: filled === required.length };
}

/** Some areas still have no “what healthy looks like” text. */
export function benchmarksIncomplete(period: CurrentPeriodResponse | null): boolean {
  const progress = definitionProgress(period);
  return Boolean(progress && !progress.complete);
}

export function canStartSnapshotCheckIn(period: CurrentPeriodResponse | null): boolean {
  return !benchmarksIncomplete(period);
}
